import { HttpParams } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { API_BASE_URL_SERVICE } from '../../../../../../projects/kiene-core/src/lib/kiene-core.config';
import { KieneBackendApiService } from '../../../../../../projects/kiene-core/src/lib/services/backend-api/kiene-backend-api.service';
import { MessageService } from '../../../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { ArticleScanSelectedEvent } from '../../../../components/article-scan-autocomplete/article-scan-autocomplete.component';
import { Material } from '../../../../warehouse/material/material';
import { BestellungInternPosition } from '../../bestellung-intern-position';

export class ArtikelUpdateDialogInput {
    position: BestellungInternPosition;
}

export class ArtikelPositionUpdate {
    ba_id: number;
    artikel_id: number;
    menge: number;
}

@Component({
    selector: 'kiene-artikel-update-dialog',
    templateUrl: './artikel-update-dialog.component.html',
    styleUrls: ['./artikel-update-dialog.component.scss'],
})
export class ArtikelUpdateDialogComponent implements OnInit {
    selectedMaterial: Material;
    mengeCtrl = new FormControl(undefined, [Validators.required]);

    constructor(
        @Inject(MAT_DIALOG_DATA) public input: ArtikelUpdateDialogInput,
        @Inject(API_BASE_URL_SERVICE) private apiBaseURL: string,
        private api: KieneBackendApiService,
        private messageService: MessageService,
        public dialogRef: MatDialogRef<ArtikelUpdateDialogComponent>,
    ) {}

    ngOnInit(): void {
        this.mengeCtrl.setValue(this.input.position.artikelmenge);
        const params = new HttpParams().set('artikel_id', this.input.position.artikel_id.toString());
        this.api.get(this.apiBaseURL + 'artikel/read_one.php', params).subscribe({
            next: (response: Material) => {
                console.log('artikel/read_one.php', response);
                this.selectedMaterial = response;
            },
            error: error => {
                console.error(error);
            },
        });
    }

    setSelectedMaterial(event: ArticleScanSelectedEvent) {
        this.selectedMaterial = event.article;
    }

    public save(): void {
        const apu = new ArtikelPositionUpdate();
        apu.ba_id = this.input.position.ba_id;
        apu.artikel_id = this.selectedMaterial.artikel_id;
        apu.menge = this.mengeCtrl.value;

        this.api.post(this.apiBaseURL + 'bestellung/artikel_update.php', apu).subscribe({
            next: () => {
                this.dialogRef.close(true);
            },
            error: error => {
                console.error(error);
                this.messageService.errorMessage('Fehler beim Speichern', error);
            },
        });
    }
}
